(function () {
    var bbObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var scripts = node.matches && node.matches('script[src*="bundle-builder.js"]')
          ? [node]
          : (node.querySelectorAll ? node.querySelectorAll('script[src*="bundle-builder.js"]') : []);
        scripts.forEach(function (scriptTag) {
          var sectionId = scriptTag.getAttribute('data-section-id');
          if (sectionId) init(sectionId);
        });
      });
    });
  });
  bbObserver.observe(document.body, { childList: true, subtree: true });
  function initAll() {
    document.querySelectorAll('script[src*="bundle-builder.js"]').forEach(function (scriptTag) {
      var sectionId = scriptTag.getAttribute('data-section-id');
      if (!sectionId) return;
      init(sectionId);
    });
  }

  initAll();

  // Re-run whenever the theme editor live-updates this section (adding/editing
  // blocks in the customizer doesn't reload the page, so we need this to see changes).
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[id^="bb-data-"]')) {
      initAll();
    }
  });
  function init(sectionId) {
    var dataEl = document.getElementById('bb-data-' + sectionId);
    var root = document.getElementById('bb-root-' + sectionId);
    if (!dataEl || !root) return;

    var config = JSON.parse(dataEl.textContent);
    var types = config.types || [];
    var tierDefs = config.tiers || [];
    var showMoreThreshold = config.showMoreThreshold || 7;
        var singlePairLabel = config.singlePairLabel || 'Single Pair';
    var pairsLabel = config.pairsLabel || 'Pairs';

    if (!types.length || !tierDefs.length) return;

      var pool = new Array(12).fill(null);

    // If we know which product this popup is showing, find which type
    // contains it and default to that type instead of always opening
    // on the first type in the list.
    var initialTypeLabel = types[0].label;
    if (config.currentProductHandle) {
      for (var ti = 0; ti < types.length; ti++) {
        var matchFound = types[ti].patterns.some(function (p) {
          return p.handle === config.currentProductHandle;
        });
        if (matchFound) {
          initialTypeLabel = types[ti].label;
          break;
        }
      }
    }

    var lastTypeLabel = initialTypeLabel;
    var lastSizeByType = {};
    var state = {
      openTier: config.defaultOpenTier || null,
      editing: null,
      pickTypeLabel: initialTypeLabel,
      expanded: false,
      pickingPatternIndex: null,
      pickQty: 1,
      pickVariantId: null,
      pickSizeTitle: null
    };

    function typeByLabel(label) {
      return types.filter(function (t) { return t.label === label; })[0];
    }

    function slotsForTier(pairs) {
      var s = pool.slice(0, pairs);
      while (s.length < pairs) s.push(null);
      return s;
    }

    function resetPicker() {
      state.editing = null;
      state.expanded = false;
      state.pickingPatternIndex = null;
      state.pickQty = 1;
      state.pickVariantId = null;
      state.pickSizeTitle = null;
    }

    function firstAvailableVariant(pattern) {
      return pattern.variants.filter(function (v) { return v.available; })[0] || pattern.variants[0];
    }

      function openFirstPairPicker(pairs) {
      var first = pool[0];
      if (!first) return;
      for (var k = 1; k < pairs; k++) {
        if (pool[k]) return;
      }
      state.editing = pairs > 1 ? 1 : 0;
      state.pickTypeLabel = first.typeLabel;
      state.pickSizeTitle = lastSizeByType[first.typeLabel] || first.sizeTitle;
    }

    function fillRemainingWithDefault(pairs) {
      var type = typeByLabel(lastTypeLabel) || types[0];
      var pattern = type.patterns[0];
      if (!pattern) return;
      var sizeTitle = lastSizeByType[type.label];
      var variant = pattern.variants.filter(function (v) { return v.size === sizeTitle; })[0] || firstAvailableVariant(pattern);
      for (var i = 0; i < pairs; i++) {
        if (!pool[i]) {
          pool[i] = { patternTitle: pattern.title, typeLabel: type.label, variantId: variant.id, sizeTitle: variant.size, image: pattern.image, isPreorder: variant.isPreorder };
      }
    }
  }

    function openMonsterCart() {
      var refreshed;
      try {
        if (typeof window.monster_refresh === 'function') {
          refreshed = window.monster_refresh();
        } else if (typeof window.monster_getCartItems === 'function') {
          refreshed = window.monster_getCartItems();
        }
      } catch (e) {
        console.error('Monster refresh error:', e);
      }
      Promise.resolve(refreshed)
        .catch(function () {})
        .then(function () {
          setTimeout(function () {
            try {
              if (typeof window.openCart === 'function') {
                window.openCart();
              } else {
                var cartLink = document.querySelector('header a[href$="/cart"], a[href$="/cart"]');
                if (cartLink) cartLink.click();
              }
            } catch (e) {
              console.error('Open cart error:', e);
            }
          }, 250);
        });
    }

    function addToCart(items, onDone) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        })
        .then(function (res) {
          if (!res.ok) {
            console.error('Bundle builder add to cart failed:', res.data);
            if (onDone) onDone(false, res.data && (res.data.description || res.data.message));
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          openMonsterCart();
          if (onDone) onDone(true);
        })
        .catch(function (e) {
          console.error('Bundle builder add to cart error:', e);
          if (onDone) onDone(false);
        });
    }

    function renderPatternPicker(pairIndex, maxPairs) {
  var panel = document.createElement('div');
  panel.className = 'bb-picker-panel';

  var title = document.createElement('p');
  title.className = 'bb-picker-title';
  title.textContent = 'Choose a pair for pair ' + (pairIndex + 1);
  panel.appendChild(title);

  var typeTabs = document.createElement('div');
  typeTabs.className = 'bb-tabs-row';
  types.forEach(function (t) {
    var tb = document.createElement('button');
    tb.type = 'button';
    tb.className = 'bb-tab' + (state.pickTypeLabel === t.label ? ' active' : '');
    tb.textContent = t.label;
    tb.addEventListener('click', function () {
      state.pickTypeLabel = t.label;
      state.expanded = false;
      state.pickSizeTitle = lastSizeByType[t.label] || (t.patterns[0] && t.patterns[0].variants[0] && t.patterns[0].variants[0].size);
      renderAll();
    });
    typeTabs.appendChild(tb);
  });
  panel.appendChild(typeTabs);

  var activeType = typeByLabel(state.pickTypeLabel) || types[0];
  if (!state.pickSizeTitle) {
    state.pickSizeTitle = lastSizeByType[activeType.label] || (activeType.patterns[0] && activeType.patterns[0].variants[0] && activeType.patterns[0].variants[0].size);
  }

  var allSizes = [];
  activeType.patterns.forEach(function (p) {
    p.variants.forEach(function (v) {
      if (allSizes.indexOf(v.size) === -1) allSizes.push(v.size);
    });
  });
  if (allSizes.length > 0) {
    var sizeLbl = document.createElement('p');
    sizeLbl.className = 'bb-step-label';
    sizeLbl.textContent = 'Size';
    panel.appendChild(sizeLbl);
    var sizeRow = document.createElement('div');
    sizeRow.className = 'bb-size-row';
    allSizes.forEach(function (sz) {
      var sbtn = document.createElement('button');
      sbtn.type = 'button';
      sbtn.className = 'bb-size-btn' + (state.pickSizeTitle === sz ? ' active' : '');
      sbtn.textContent = sz;
      sbtn.addEventListener('click', function () {
        state.pickSizeTitle = sz;
        var cur = (state.editing !== null) ? pool[state.editing] : null;
        if (cur && cur.typeLabel === activeType.label) {
          var curPattern = activeType.patterns.filter(function (p) { return p.title === cur.patternTitle; })[0];
          var newVariant = curPattern && curPattern.variants.filter(function (v) { return v.size === sz && v.available; })[0];
          if (newVariant) {
            pool[state.editing] = {
              patternTitle: cur.patternTitle,
              typeLabel: cur.typeLabel,
              variantId: newVariant.id,
              sizeTitle: newVariant.size,
              image: cur.image,
              isPreorder: newVariant.isPreorder
            };
            lastSizeByType[activeType.label] = newVariant.size;
          }
        }
        renderAll();
      });
      sizeRow.appendChild(sbtn);
    });
    if (activeType.sizeChartImage) {
  var sizeChartBtn = document.createElement('button');
  sizeChartBtn.type = 'button';
  sizeChartBtn.className = 'bb-sizechart-btn';
  sizeChartBtn.textContent = 'Size Chart';
  sizeChartBtn.addEventListener('click', function () {
    openSizeChart(activeType.sizeChartImage);
  });
  sizeRow.appendChild(sizeChartBtn);
}
    panel.appendChild(sizeRow);
  }

  var shown = activeType.patterns;

  var grid = document.createElement('div');
  grid.className = 'bb-pattern-grid';
  shown.forEach(function (pattern) {
    var cell = document.createElement('div');
    cell.className = 'bb-swatch';
    var img = pattern.image ? '<img src="' + pattern.image + '" alt="' + pattern.title + '">' : '<div class="bb-box"></div>';
    var variantForSize = pattern.variants.filter(function (v) { return v.size === state.pickSizeTitle; })[0];
      var preorderBadge = (variantForSize && variantForSize.isPreorder) ? '<span class="bb-preorder-badge">Preorder</span>' : '';
      cell.innerHTML = img + preorderBadge;
      if (pattern.images && pattern.images.length) {
  var infoBtn = document.createElement('span');
  infoBtn.className = 'bb-patterninfo-btn';
  infoBtn.setAttribute('role', 'button');
  infoBtn.setAttribute('aria-label', 'More info');
  infoBtn.textContent = 'i';
  infoBtn.addEventListener('click', function (e) {
  e.stopPropagation();
  openPatternInfo(pattern, function () {
    var variant = pattern.variants.filter(function (v) { return v.size === state.pickSizeTitle && v.available; })[0]
      || firstAvailableVariant(pattern);
    pool[state.editing] = {
      patternTitle: pattern.title,
      typeLabel: activeType.label,
      variantId: variant.id,
      sizeTitle: variant.size,
      image: pattern.image,
      isPreorder: variant.isPreorder
    };
    lastTypeLabel = activeType.label;
    lastSizeByType[activeType.label] = variant.size;
    resetPicker();
    renderAll();
  });
});
  cell.appendChild(infoBtn);
}
    cell.addEventListener('click', function () {
      var variant = pattern.variants.filter(function (v) { return v.size === state.pickSizeTitle && v.available; })[0]
        || firstAvailableVariant(pattern);
      pool[state.editing] = {
        patternTitle: pattern.title,
        typeLabel: activeType.label,
        variantId: variant.id,
        sizeTitle: variant.size,
        image: pattern.image,
        isPreorder: variant.isPreorder
      };
      lastTypeLabel = activeType.label;
      lastSizeByType[activeType.label] = variant.size;
      resetPicker();
      renderAll();
    });
    grid.appendChild(cell);
  });
  panel.appendChild(grid);

  return panel;
}
      

    function renderTierBody(def) {
      var body = document.createElement('div');
      body.className = 'bb-tier-body';

      var slots = slotsForTier(def.pairs);
      var grid = document.createElement('div');
      grid.className = 'bb-slot-grid';
           slots.forEach(function (slot, i) {
        var box = document.createElement('div');
        box.className = 'bb-slot' + (slot ? ' filled' : '') + (state.editing === i ? ' active' : '');
        box.innerHTML = slot
            ? '<span class="bb-slot-remove">✕</span>' + (slot.image ? '<img class="bb-slot-img" src="' + slot.image + '" alt="' + slot.patternTitle + '">' : '') + '<p class="bb-pattern-size">' + slot.sizeTitle + '</p>' + (slot.isPreorder ? '<p class="bb-preorder-note">Preorder' + (config.preorderDate ? ' ' + config.preorderDate : '') + '</p>' : '')
          : '<span class="bb-plus">+</span><p class="bb-lbl">Pair ' + (i + 1) + '</p>';
        if (slot) {
          var removeBtn = box.querySelector('.bb-slot-remove');
          removeBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            pool[i] = null;
            resetPicker();
            renderAll();
          });
        }
        box.addEventListener('click', function () {
          resetPicker();
          state.editing = i;
          state.pickTypeLabel = slot ? slot.typeLabel : lastTypeLabel;
          var t = typeByLabel(state.pickTypeLabel) || types[0];
          var patternIdx = 0;
          if (slot) {
            patternIdx = t.patterns.findIndex(function (p) { return p.title === slot.patternTitle; });
            if (patternIdx < 0) patternIdx = 0;
          }
          state.pickingPatternIndex = patternIdx;
          var pattern = t.patterns[patternIdx];
          if (pattern) {
            var variant = slot
              ? pattern.variants.filter(function (v) { return v.id === slot.variantId; })[0] || firstAvailableVariant(pattern)
              : (function () {
                  var wanted = lastSizeByType[t.label];
                  return pattern.variants.filter(function (v) { return v.size === wanted && v.available; })[0] || firstAvailableVariant(pattern);
                })();
            state.pickVariantId = variant.id;
            state.pickSizeTitle = variant.size;
          }
          renderAll();
        });
        grid.appendChild(box);
      });
      body.appendChild(grid);

      if (state.editing !== null) {
        body.appendChild(renderPatternPicker(state.editing, def.pairs));
      }

      var cta = document.createElement('button');
      cta.type = 'button';
      cta.className = 'bb-cta';
      cta.textContent = 'Add To Cart';
      cta.addEventListener('click', function () {
        var items = slotsForTier(def.pairs)
          .filter(function (s) { return s; })
          .map(function (s) {
            return { id: s.variantId, quantity: 1 };
          });
        if (!items.length) return;
        cta.disabled = true;
        cta.textContent = 'Adding…';
        addToCart(items, function (ok, msg) {
          cta.disabled = false;
          cta.textContent = ok ? 'Added!' : (msg || 'Something went wrong — try again');
          pool = [];
          resetPicker();
          setTimeout(renderAll, ok ? 800 : 1500);
        });
      });
      body.appendChild(cta);

            if (config.trustLine) {
        var trust = document.createElement('p');
        trust.className = 'bb-trust-line';
        trust.textContent = config.trustLine;
        body.appendChild(trust);
      }

      if (config.paymentIconsHtml) {
        var payRow = document.createElement('div');
        payRow.className = 'bb-pay-row';
        payRow.innerHTML = config.paymentIconsHtml;
        body.appendChild(payRow);
      }

      return body;
    }

    function renderTiers() {
      root.innerHTML = '';
      tierDefs.forEach(function (def) {
        var slots = slotsForTier(def.pairs);
        var wrap = document.createElement('div');
        var open = state.openTier === def.pairs;
        wrap.className = 'bb-tier' + (def.quiet ? ' quiet' : '') + (open ? ' open' : '');

        var picked = slots.filter(function (s) { return s; }).length;

        var head = document.createElement('div');
        head.className = 'bb-tier-head';
        var badge = def.bestSeller ? '<span class="bb-best-badge">' + (def.badgeLabel || 'Best seller') + '</span>' : '';
        var singlePairDef = tierDefs.filter(function (t) { return t.pairs === 1; })[0] || tierDefs[0];
        var basePrice = singlePairDef ? Number(singlePairDef.price) : 0;
        var originalTotal = basePrice * def.pairs;
        var showCompare = def.pairs > 1 && originalTotal > Number(def.price);
        var priceHtml = '<span class="bb-tier-price">' +
          (showCompare ? '<span class="bb-price-was">' + def.compareFormatted + '</span>' : '') +
          '<span class="bb-price-now">' + def.priceFormatted + '</span>' +
          '</span>';
        var titleText = def.customTitle ? def.customTitle : (def.pairs === 1 ? singlePairLabel : def.pairs + ' ' + pairsLabel);
        var subText = def.pairs === 1
        ? 'Just one pair'
        : picked + ' of ' + def.pairs + ' added';
        head.innerHTML =
          '<div class="bb-tier-head-main"><div class="bb-title-row"><p class="bb-tier-title">' + titleText + '</p>' + badge + '</div>' +
          '<p class="bb-tier-sub">' + subText + '</p></div>' +
          '<div style="text-align:right;">' + priceHtml + '<div><span class="bb-chev' + (open ? ' open' : '') + '">▾</span></div></div>';
        head.addEventListener('click', function () {
          state.openTier = open ? null : def.pairs;
          resetPicker();
          if (!open) openFirstPairPicker(def.pairs);
          renderAll();
        });
        wrap.appendChild(head);

        if (def.note) {
          var perk = document.createElement('div');
          perk.className = 'bb-perk-banner';
          perk.innerHTML = '<span class="bb-perk-icon"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4"></rect><path d="M12 8v13"></path><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"></path><path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8z"></path><path d="M16.5 8a2.5 2.5 0 0 0 0-5C13 3 12 8 12 8z"></path></svg></span><span>' + def.note + '</span>';
          wrap.appendChild(perk);
        }

        if (open) wrap.appendChild(renderTierBody(def));
        root.appendChild(wrap);

        
        
      });
    }

      function renderAll() {
  var openBody = root.querySelector('.bb-tier.open .bb-tier-body');
  var savedScroll = openBody ? openBody.scrollTop : 0;
  renderTiers();
  var newBody = root.querySelector('.bb-tier.open .bb-tier-body');
  if (newBody) newBody.scrollTop = savedScroll;
  if (window.innerWidth >= 990) positionBesideImage();
}

    // Pre-fill Pair 1 with the pattern the builder was opened from
    if (config.currentProductHandle) {
      for (var pi = 0; pi < types.length; pi++) {
        var preType = types[pi];
        var prePattern = preType.patterns.filter(function (p) { return p.handle === config.currentProductHandle; })[0];
        if (prePattern && prePattern.variants.length) {
          var preVariant = firstAvailableVariant(prePattern);
          pool[0] = {
            patternTitle: prePattern.title,
            typeLabel: preType.label,
            variantId: preVariant.id,
            sizeTitle: preVariant.size,
            image: prePattern.image,
            isPreorder: preVariant.isPreorder
          };
          lastTypeLabel = preType.label;
          lastSizeByType[preType.label] = preVariant.size;
          state.pickTypeLabel = preType.label;
          if (state.openTier) openFirstPairPicker(state.openTier);
          break;
        }
      }
    }

    renderAll();
  }
  function openPatternInfo(pattern, onSelect) {
  closePatternInfo();
  var overlay = document.createElement('div');
  overlay.className = 'bb-sizechart-overlay';
  overlay.addEventListener('click', closePatternInfo);

  var modal = document.createElement('div');
  modal.className = 'bb-patterninfo-modal';

  var closeBtn = document.createElement('span');
  closeBtn.className = 'bb-sizechart-modal-close';
  closeBtn.textContent = '✕';
  closeBtn.addEventListener('click', closePatternInfo);

  var title = document.createElement('p');
  title.className = 'bb-patterninfo-title';
  title.textContent = pattern.title;

  var imagesWrap = document.createElement('div');
  imagesWrap.className = 'bb-patterninfo-images';
  (pattern.images || []).forEach(function (src) {
    var im = document.createElement('img');
    im.src = src;
    im.alt = pattern.title;
    imagesWrap.appendChild(im);
  });

  var desc = document.createElement('p');
  desc.className = 'bb-patterninfo-desc';
  desc.textContent = pattern.description || '';

  modal.appendChild(closeBtn);
  modal.appendChild(title);
  modal.appendChild(imagesWrap);
  modal.appendChild(desc);
  var selectBtn = document.createElement('button');
selectBtn.type = 'button';
selectBtn.className = 'bb-cta';
selectBtn.style.marginTop = '10px';
var wrapperEl = document.querySelector('.bb-wrapper');
if (wrapperEl) {
  var wrapperStyles = getComputedStyle(wrapperEl);
  selectBtn.style.background = wrapperStyles.getPropertyValue('--bb-cta-bg');
  selectBtn.style.borderColor = wrapperStyles.getPropertyValue('--bb-cta-bg');
  selectBtn.style.color = wrapperStyles.getPropertyValue('--bb-cta-text');
}
selectBtn.textContent = 'Add To Cart';
selectBtn.addEventListener('click', function () {
  closePatternInfo();
  if (onSelect) onSelect();
});
modal.appendChild(selectBtn);
  document.body.appendChild(overlay);
  document.body.appendChild(modal);
}

function closePatternInfo() {
  document.querySelectorAll('.bb-sizechart-overlay, .bb-patterninfo-modal').forEach(function (el) {
    el.remove();
  });
}
  function openSizeChart(imageUrl) {
  closeSizeChart();
  var overlay = document.createElement('div');
  overlay.className = 'bb-sizechart-overlay';
  overlay.addEventListener('click', closeSizeChart);

  var modal = document.createElement('div');
  modal.className = 'bb-sizechart-modal';

  var closeBtn = document.createElement('span');
  closeBtn.className = 'bb-sizechart-modal-close';
  closeBtn.textContent = '✕';
  closeBtn.addEventListener('click', closeSizeChart);

  var img = document.createElement('img');
  img.src = imageUrl;
  img.alt = 'Size chart';

  modal.appendChild(closeBtn);
  modal.appendChild(img);
  document.body.appendChild(overlay);
  document.body.appendChild(modal);
}

function closeSizeChart() {
  document.querySelectorAll('.bb-sizechart-overlay, .bb-sizechart-modal').forEach(function (el) {
    el.remove();
  });
}
function positionBesideImage() {
  var wrapper = document.querySelector('.bb-wrapper');
  if (!wrapper) return;

  var spacer = wrapper.nextElementSibling;
  if (!spacer || !spacer.classList.contains('bb-spacer')) {
    spacer = document.createElement('div');
    spacer.className = 'bb-spacer';
    wrapper.parentNode.insertBefore(spacer, wrapper.nextSibling);
  }

  function updateSpacer() {
    var imageCol = document.querySelector('.product__primary-left');
    if (!wrapper.classList.contains('bb-positioned') || !imageCol) {
      spacer.style.height = '';
      return;
    }
    var overflow = wrapper.offsetHeight - imageCol.offsetHeight;
    spacer.style.height = Math.max(0, overflow) + 'px';
  }

  if (!wrapper._bbResizeObserver) {
    wrapper._bbResizeObserver = new ResizeObserver(updateSpacer);
    wrapper._bbResizeObserver.observe(wrapper);
  }

  if (window.innerWidth < 990) {
    wrapper.classList.remove('bb-positioned');
    wrapper.style.top = '';
    wrapper.style.left = '';
    wrapper.style.width = '';
    spacer.style.height = '';
    return;
  }
  var imageCol = document.querySelector('.product__primary-left');
  var detailsCol = document.querySelector('.product__primary-right');
  if (!imageCol || !detailsCol) return;
  var imgRect = imageCol.getBoundingClientRect();
  var detRect = detailsCol.getBoundingClientRect();
  var scrollTop = window.scrollY || document.documentElement.scrollTop;
  var scrollLeft = window.scrollX || document.documentElement.scrollLeft;
  wrapper.classList.add('bb-positioned');
  wrapper.style.top = (imgRect.top + scrollTop) + 'px';
  wrapper.style.left = (detRect.left + scrollLeft) + 'px';
  wrapper.style.width = (window.innerWidth - detRect.left - 40) + 'px';
  updateSpacer();
}
  window.addEventListener('load', positionBesideImage);
  window.addEventListener('resize', positionBesideImage);
  document.addEventListener('shopify:section:load', function () {
    setTimeout(positionBesideImage, 50);
  });
})();